import { waitForElem } from '../../utils/wait_for_elem';

function getCsrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return meta?.content ?? '';
}

waitForElem('a.image_large_view').then((elems) => {
  elems?.forEach((image) => {
    image?.addEventListener('click', (e) => {
      e.preventDefault()
      const href = image.getAttribute('href')
      if (href) {
        image.setAttribute('src', href)
        image.setAttribute('target', '_blank')
        window.open(
          image.getAttribute('src') ?? undefined,
          "Image",
          `width=${image.getAttribute('width')},height=${image.getAttribute('height')}`
        )
      }
    })
  })
})

waitForElem('.share-button').then((elems) => {
  elems?.forEach((btn) => {
    btn?.addEventListener('click', () => {
      const csrftoken = getCsrfToken()
      const loc = window?.location?.href
      if (loc) {
        const headers: HeadersInit = {};
        if (csrftoken) headers['X-CSRFToken'] = csrftoken;
        fetch('/update_share_count/', {
          headers,
          body: JSON.stringify({ 'url': loc }),
          method: "POST"
        })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err)
          })
      }
    });
  });
});
